module.exports = __webpack_public_path__ + "img/defaultpage_img_null@2x.d32e7520.png";